import React from 'react';
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import Features from '../components/Features';
import WhyChooseUs from '../components/WhyChooseUs';
import ShopByShape from '../components/ShopByShape';
import Craftsmanship from '../components/Craftsmanship';
import Certificate from '../components/certificate';
const Home = () => {
  return (
    <main>
      <Hero />
      <ShopByShape />
      <Features />
      <AboutUs />
      <WhyChooseUs />
      <Craftsmanship />
      <Certificate />
    </main>
  );
};

export default Home;
